import { FREQUENCY_CAPPING_FIELDS, TIME_PERIOD_UNIT } from '@openx/types/frequencyCapping.ts';
import type { I18nTranslate } from '@openx/types/translations.ts';

export const DEFAULT_FREQUENCY_CAPPING_ENTRY = {
  [FREQUENCY_CAPPING_FIELDS.TIME_PERIOD_UNIT]: '',
  [FREQUENCY_CAPPING_FIELDS.TIME_PERIOD_VALUE]: 1,
  [FREQUENCY_CAPPING_FIELDS.IMPRESSIONS_LIMIT]: '',
} as const;

export const MAX_FREQUENCY_CAPPING_ENTRIES = 3;

export const FREQUENCY_CAPPING_ALERT_MAX_WIDTH = '550px';

export const FREQUENCY_CAPPING_IMPRESSIONS_LIMIT_MAX = 1000000000000000000n;
export const FREQUENCY_CAPPING_IMPRESSIONS_LIMIT_MAX_LABEL = '1.000.000.000.000.000.000';

export const getTimePeriodOptions = (t: I18nTranslate): Record<string, string> => ({
  '': t('Select a Time Unit'),
  [TIME_PERIOD_UNIT.HOUR]: t('Hours'),
  [TIME_PERIOD_UNIT.DAY]: t('Days'),
  [TIME_PERIOD_UNIT.WEEK]: t('Weeks'),
});

export const buildFieldName = (baseName: string, index: number, field: string): string =>
  `${baseName}.${index}.${field}`;
